<template>
  <v-container fluid pl-0 pr-0>
    <v-row align="center" justify="center" class="pt-6">
      <v-col cols="6">
        <CONTENT />
      </v-col>
    </v-row>
    <v-row align="center" justify="center" class="pt-6">
      <v-col cols="12">
        <MEM />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import CONTENT from "../components/About/Content.vue";
import MEM from "../components/About/Members.vue";
export default {
  components: {
    CONTENT,
    MEM
  }
};
</script>